import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { AdviserConfigurationCollection } from '../../Models/Models/Adviser/Configuration/AdviserConfigurationCollection';

declare var IS_RUNNING_IN_APP_POOL;

export class AdviserConfigurationHistoryClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyId: string, minrow: number, maxrow: number): Promise<AdviserConfigurationCollection, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Adviser/AdviserConfigurationHistory/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, minrow: minrow, maxrow: maxrow }

    return AjaxWrapper.get<AdviserConfigurationCollection, any>(url, data);
  }
}

